import {validate as validator} from "validate.js";

const rules = () => {
    return {
        name: {
            presence: true,
            length: {
                minimum: 2,
            }
        },
        email: {
            presence: true,
            email: true
        },
        phone: {
            presence: true,
            length: {
                minimum: 7,
            }
        },
    }
};

const validate = (growerParent) => {
    return validator(growerParent, rules())
};

export default {validate};
